// extracted by mini-css-extract-plugin
export var aircallIframe = "_g5-3";
export var fabContainer = "_g5-5";
export var fabRinging = "_g5-6";
export var loadingOverlay = "_g5-4";
export var pulse = "_g5-7";
export var widgetContent = "_g5-2";
export var widgetPanel = "_g5-0";
export var widgetPanelExpanded = "_g5-1";